export var SDK_VERSION = '6.18.1';
//# sourceMappingURL=version.js.map